import { apiFetch } from "./client";
import type { Notification, NotificationRule, NotificationTemplate, Page } from "./types";

export async function listNotifications(
  limit = 50,
  offset = 0,
): Promise<Page<Notification>> {
  return apiFetch<Page<Notification>>(
    `/notifications?limit=${limit}&offset=${offset}`,
  );
}

export async function markNotificationRead(id: number): Promise<void> {
  return apiFetch<void>(`/notifications/${id}/read`, { method: "POST" });
}

export async function readAllNotifications(): Promise<void> {
  return apiFetch<void>("/notifications/read-all", { method: "POST" });
}

export async function listNotificationTemplates(): Promise<NotificationTemplate[]> {
  return apiFetch<NotificationTemplate[]>("/notifications/templates");
}

export interface NotificationTemplateInput {
  locale: string;
  channel: "in_app" | "email";
  subject: string | null;
  body: string;
}

export async function createNotificationTemplate(
  eventType: string,
  data: NotificationTemplateInput,
): Promise<NotificationTemplate> {
  return apiFetch<NotificationTemplate>(
    `/notifications/templates?event_type=${encodeURIComponent(eventType)}`,
    { method: "POST", body: JSON.stringify(data) },
  );
}

export async function updateNotificationTemplate(
  id: number,
  data: NotificationTemplateInput,
): Promise<NotificationTemplate> {
  return apiFetch<NotificationTemplate>(`/notifications/templates/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function listNotificationRules(): Promise<NotificationRule[]> {
  return apiFetch<NotificationRule[]>("/notifications/rules");
}

export interface NotificationRuleInput {
  required_permission: string | null;
  channels: string[];
  is_enabled: boolean;
}

export async function updateNotificationRule(
  id: number,
  data: NotificationRuleInput,
): Promise<NotificationRule> {
  return apiFetch<NotificationRule>(`/notifications/rules/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}
